var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.98 22.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#123876;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.82,18.63a11,11,0,0,0-4.63,1.86,11,11,0,0,0,12.6,0,11,11,0,0,0-4.63-1.86"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 3.15,
    width: 21.98,
    height: 13.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.64,3.15a11,11,0,0,0-14.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.16,16.53v2.1a11,11,0,0,1,4.63,1.86,11.09,11.09,0,0,0,3.46-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.73,16.53a11.09,11.09,0,0,0,3.46,4,11,11,0,0,1,4.63-1.86v-2.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.94,
    y1: 5.59,
    x2: 5.94,
    y2: 16.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.63,
    y1: 5.59,
    x2: 22.48,
    y2: 5.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.01,
    y1: 8.02,
    x2: 4.58,
    y2: 8.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.01,
    y1: 9.95,
    x2: 4.58,
    y2: 9.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.01,
    y1: 11.87,
    x2: 4.58,
    y2: 11.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.01,
    y1: 13.8,
    x2: 4.58,
    y2: 13.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.62,
    y1: 8.02,
    x2: 13.61,
    y2: 8.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.62,
    y1: 9.95,
    x2: 13.61,
    y2: 9.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.62,
    y1: 11.87,
    x2: 13.61,
    y2: 11.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.62,
    y1: 13.8,
    x2: 13.61,
    y2: 13.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.41,
    y1: 11.87,
    x2: 20.41,
    y2: 11.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.41,
    y1: 13.8,
    x2: 20.41,
    y2: 13.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.32,
    cy: 8.97,
    r: 1.32
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.b5b15622efd410b6770fcb00bb8e5c82.svg";
export { ForwardRef as ReactComponent };